module.exports = __webpack_public_path__ + "static/media/I_am_a_host_for_the_hypno_virus.5ec5a502.mp3";